<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: "PageTitleWithArt",
  props: ["tealText","blackText","twoLines","kind"]
});
</script>

<style scoped>

.white-heart {
  left:auto;
  width:30px;
  right:10px; 
  top:10px;
}
.img {
  width:300px;
}
.waves > img {
  object-fit:contain; 
  object-position:bottom;
  width:100%; 
  height:auto;
}

.headline {
  padding-right:50px; 
  padding-bottom:60px;
}


/*less than md*/
@media (max-width : 960px) {

  .visible-gtm {
    display:none;
  }

  .ltm-left {
    padding-left:15px;
  }

  .waves > img {
    object-fit:cover; 
    width:100%; 
    height:60px;
    object-position:0px;
  }

  .invisible-ltm {
    display:none;
  }

  .headline {
    padding-right:0px; 
    padding-bottom:20px;
    margin-top:20px;
  }

}

.ambulance {
  width:300px;
}
.star {
  margin-top:30px;
  margin-bottom:40px;
}
.ambulance > div.sb-abox {
  width:120%;
  top:-215px;
  left:-20%;
}

.sb-explicit.three-happy-pros {
  width:400px !important;
  margin-left:-33px !important;
}

@media (max-width : 1250px) {
  .ambulance > div.sb-abox {
    width:120%;
    top:-170px;
    left:-20%;
  }
  .ambulance {
    width:250px;
  }

  .sb-explicit.three-happy-pros {
    width:300px !important;
    margin-left:-33px !important;
  }
  
}

@media (max-width : 1150px) {
  .ambulance > div.sb-abox {
    width:120%;
    top:-130px;
    left:-20%;
  }
  .ambulance {
    display:none;
  }
  .star {
    margin-top:30px;
    margin-bottom:20px;
  }
}

@media (max-width : 960px) {
  .star-headline {
    font-size:2rem;
  }
  .ambulance {
    display:flex;
    width:300px;
  }
  .ambulance > div.sb-abox {
    width:100%;
    top:-160px;
    left:0%;
  }
  .star {
    margin-top:20px;
    margin-bottom:45px;
  }

  .sb-explicit.three-happy-pros {
    width:50% !important;
  }

}

@media (max-width : 800px) {
  .star-headline {
    font-size:2rem;
  }
  .ambulance {
    width:250px;
  }
  .ambulance > div.sb-abox {
    width:90%;
    top:-120px;
    left:10%;
  }
  .star {
    margin-top:0px;
    margin-bottom:30px;
  }
}
@media (max-width : 700px) {
  .star-headline {
    font-size:1.7rem;
  }
  .ambulance {
    width:200px;
  }
  .ambulance > div.sb-abox {
    width:90%;
    top:-120px;
    left:0%;
  }
  .star {
    margin-top:0px;
    margin-bottom:20px;
  }

  .sb-explicit.three-happy-pros {
    width:100% !important;
  }
}
@media (max-width : 600px) {
  .star-headline {
    font-size:1.5rem;
  }
  .ambulance {
    width:150px;
  }
  .ambulance > div.sb-abox {
    width:90%;
    top:-100px;
    left:-10%;
  }
}

@media (max-width : 600px) {
  .star-headline {
    font-size:1.5rem;
  }
  .ambulance {
    width:120px;
  }
  .ambulance > div.sb-abox {
    width:90%;
    top:-80px;
    left:-10%;
  }
}

@media (max-width : 500px) {
  .star-headline {
    font-size:1.5rem;
  }
  .ambulance {
    display:none;
  }
  .star {
    margin-bottom:0px;
  }
}
@media (max-width : 400px) {
  .star-headline {
    font-size:1.2rem;
  }
}


</style>


<template>


    <div v-if="kind == 'star'" class="sb sb-h sb-greedy-1 sb-alt2 sb-ltm-alt2 sb-ltm-align-ch sb-align-2bottom ltm-left star">
      
      <h1 class="sb sb-greedy sb-text headline star-headline">
        <span class="teal">{{tealText}}</span>&nbsp;<br v-if="twoLines">{{blackText}}
        <span class="sb-abox waves invisible-ltm" style="width:100%; bottom:0px; height:50px; left:0px;">
          <img src="@images/STHS-WeCare-Blue-background-waves_wave2.png" alt="decorative blue waves" style="object-fit:fill; width:100%; height:100%;"/>
        </span>
        <div class="sb-abox" style="width:40px; left:-32px; top:-18px;">
          <img src="@images/STHS-WeCare-logo_heart.png" alt="WeCare logo" style="object-fit:contain; width:100%; height:auto;"/>
        </div>
      </h1>

      <div class="sb sb-explicit sb-h sb-alt2 sb-align-2bottom ambulance">  
        <div class="sb-abox">
          <img src="@images/STHS-WeCare-ambulance-resized.png" alt="Ambulance" style="width:100%; height:auto; object-fit:contain;">
        </div>
      </div>
      
    </div>

    <div v-else class="sb sb-h sb-ltm-h2v sb-greedy-1 sb-gr sb-alt2 sb-ltm-alt2 sb-ltm-align-ch sb-align-2bottom sb-content-space-between ltm-left">
      
      <h1 class="sb sb-greedy sb-text headline">
        <span class="teal">{{tealText}}</span>&nbsp;<br v-if="twoLines">{{blackText}}
        <span class="sb-abox waves invisible-ltm" style="width:100%; bottom:0px; height:50px; left:0px;">
          <img src="@images/STHS-WeCare-Blue-background-waves_wave2.png" alt="decorative blue waves" style="object-fit:fill; width:100%; height:100%;"/>
        </span>
        <div class="sb-abox" style="width:40px; left:-32px; top:-18px;">
          <img src="@images/STHS-WeCare-logo_heart.png" alt="WeCare logo" style="object-fit:contain; width:100%; height:auto;"/>
        </div>
      </h1>
      <div class="sb three-happy-pros sb-explicit sb-h sb-alt2 sb-align-2bottom">
        <img src="@images/All-These-Doctors-and-Nurses-Standing-And-Smiling-Cropped.png" alt="Smiling healthcare professionals" style="width:100%; height:auto; object-fit:contain;">
      </div>

    </div>

</template>

